/**
 * RateApp element.
 */
const rateApp = {};

// Constants
const SELECTOR = '.hom-js-rateApp';
const DATA = {
    action: 'rateApp',
    appID: {
        android: $(SELECTOR).data('id-android'),
        ios: $(SELECTOR).data('id-ios')
    }
};

/**
 * Attach rateApp element event listener.
 */
rateApp.addEventListener = function () {
    $('body').on('click', SELECTOR, function (e) {
        e.preventDefault();

        try {
            window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
        } catch (error) {
            console.error(error);
        }
    });
};

module.exports = rateApp;
